import classNames from "classnames";
import React from "react";

export default function ({
  id,
  value,
  name,
  onChange,
  className,
  title,
  checked,
}) {
  return (
    <label
      htmlFor={id}
      className={classNames("modals-radio", { [className]: !!className })}
    >
      <input
        type="radio"
        id={id}
        value={value}
        name={name}
        onChange={onChange}
        checked={checked}
      />
      <div>{title}</div>
    </label>
  );
}
